import { Schema } from "./schema";
import { LocationPreferences } from "../../../models/LocationPreferences";

export const generateDefaultValues = (data: LocationPreferences): Schema => {
  return {
    manages_gbp_review_replies: data.manages_gbp_review_replies
  };
};
